export default __webpack_public_path__ + "static/media/ilha_4.b7b757cd.jpg";